/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Button Styles
import root from "assets/theme/components/button/root";
import contained from "assets/theme/components/button/contained";
import outlined from "assets/theme/components/button/outlined";
import buttonText from "assets/theme/components/button/text";

import buttonStyles from "assets/buttonStyles";
import colors from "assets/theme/base/colors";

const button = {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    root: { ...root },
    contained: ({ ownerState }) => ({
      ...contained.base,
      ...buttonStyles({
        palette: colors,
        color: ownerState.color,
        variant: "contained",
        dark: false,
      }),
    }),
    containedSizeSmall: { ...contained.small },
    containedSizeLarge: { ...contained.large },
    outlined: ({ ownerState }) => ({
      ...outlined.base,
      ...buttonStyles({
        palette: colors,
        color: ownerState.color,
        variant: "outlined",
        dark: false,
      }),
    }),
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    text: ({ ownerState }) => ({
      ...buttonText.base,
      ...buttonStyles({ palette: colors, color: ownerState.color, variant: "text", dark: false }),
    }),
    textSizeSmall: { ...buttonText.small },
    textSizeLarge: { ...buttonText.large },
  },
};

export default button;
